// extracted by mini-css-extract-plugin
export var container = "_7t-0";
export var icon = "_7t-1";
export var text = "_7t-2";